import { UserManagementPageProps } from './user-management-page.types'
import { PageContainer, PageHeader } from '@touche-lts/panel-ui/dist'
import { IconUserManagement } from 'assets/icons'
import { UsersTable } from './users-table'

const UserManagementPageComponent = (props: UserManagementPageProps) => {
  const {
    className,
    style,
    history: { push }
  } = props

  return (
    <PageContainer className={className} style={style}>
      <PageHeader
        navSegments={[
          {
            icon: IconUserManagement,
            label: 'User management',
            iconProps: { viewBox: '0 0 22 22' }
          }
        ]}
        buttons={[
          {
            preset: 'primary',
            children: 'Add user',
            onClick: () => push('/user-management/add-user')
          }
        ]}
      />
      <UsersTable />
    </PageContainer>
  )
}

const UserManagementPage = UserManagementPageComponent
export { UserManagementPage }
